// extracted by mini-css-extract-plugin
export default {"container":"Details_container__rwrOZ","content":"Details_content__EnQdx","sideNav":"Details_sideNav__+1dBe","sideNavContent":"Details_sideNavContent__Q8P2J"};